import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-teeth",
  "use": "icon-si-glyph-teeth-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-teeth\" id=\"icon-si-glyph-teeth\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1110</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M14.715,9.02 C14.715,12.045 14.151,15.887 12.434,15.887 C9.62,15.887 10.916,10.001 8.491,10.001 C6.066,10.001 6.886,15.918 4.569,15.918 C2.94,15.918 2.292,12.002 2.292,9.02 C2.292,7.213 -0.101,4.249 1.672,1.628 C3.846,-1.586 5.94,0.952 8.437,0.952 C10.972,0.952 12.949,-1.533 15.265,1.628 C17.101,4.137 14.715,7.244 14.715,9.02 L14.715,9.02 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-teeth.svg
// module id = /hdn
// module chunks = 62